export default "__VITE_ASSET__Jxj6quEF__"